// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--RaB6D{0%{background-position:200% 0}100%{background-position:-200% 0}}.about-page-container--nLWZ1 .section-1--sruYL{background-color:#fafafb}.about-page-container--nLWZ1 .section-2--ZWxpq,.about-page-container--nLWZ1 .section-3--oZfkj{background-color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"about-page-container": "about-page-container--nLWZ1",
	"section-1": "section-1--sruYL",
	"section-2": "section-2--ZWxpq",
	"section-3": "section-3--oZfkj",
	"shimmer-loading": "shimmer-loading--RaB6D"
};
export default ___CSS_LOADER_EXPORT___;
